// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"8c4c6c29","513":"3667061a"}[chunkId] + ".chunk.css";
};